import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {SignupState} from '@local/redux/state/pages/signupState';

const initialState: SignupState = {
  email: '',
  registering: false,
};
const signupSlice = createSlice({
  name: 'signup',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<Partial<SignupState>>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    clear: () => initialState,
  },
});
export const signupReducer = signupSlice.reducer;
export const signupActions = signupSlice.actions;
